export default "__VITE_ASSET__92a50cde__"